module.exports = __webpack_public_path__ + "img/sun.3e2c7718.png";